<app-navbar></app-navbar> <div class=""> <router-outlet></router-outlet> </div>